/* eslint-disable */
export default {
    beforeAfter() {
        const slider = document.getElementById('before-after-slider');
        const before = document.getElementById('before-image');
        const beforeImage = before.getElementsByTagName('img')[0];
        const resizer = document.getElementById('resizer');

        let active = false;

        //Sort overflow out for Overlay Image
        document.addEventListener("DOMContentLoaded", function() {
            let width = slider.offsetWidth;
            beforeImage.style.width = width + 'px';
        });

        //Adjust width of image on resize 
        window.addEventListener('resize', function() {
            let width = slider.offsetWidth;
            beforeImage.style.width = width + 'px';
        });

        resizer.addEventListener('mousedown',function(){
            active = true;
            resizer.classList.add('resize');
        });

        document.body.addEventListener('mouseup',function(){
            active = false;
            resizer.classList.remove('resize');
        });

        document.body.addEventListener('mouseleave', function() {
            active = false;
            resizer.classList.remove('resize');
        });

        document.body.addEventListener('mousemove',function(e){
            if (!active) return;
            let x = e.pageX;
            x -= slider.getBoundingClientRect().left;
            slideIt(x);
            pauseEvent(e);
        });

        resizer.addEventListener('touchstart',function(){
            active = true;
            resizer.classList.add('resize');
        });

        document.body.addEventListener('touchend',function(){
            active = false;
            resizer.classList.remove('resize');
        });

        document.body.addEventListener('touchcancel',function(){
            active = false;
            resizer.classList.remove('resize');
        });

        //calculation for dragging on touch devices
        document.body.addEventListener('touchmove',function(e){
            if (!active) return;
            let x;
            
            let i;
            for (i=0; i < e.changedTouches.length; i++) {
                x = e.changedTouches[i].pageX; 
            }
            
            x -= slider.getBoundingClientRect().left;
            slideIt(x);
            pauseEvent(e);
        });

        function slideIt(x){
            let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
            before.style.width = transform+"px";
            resizer.style.left = transform-0+"px";
        }

        //stop divs being selected.
        function pauseEvent(e){
            if(e.stopPropagation) e.stopPropagation();
            if(e.preventDefault) e.preventDefault();
            e.cancelBubble=true;
            e.returnValue=false;
            return false;
        }
    },

    modalHomeInit() {
        function setCookie(cname,cvalue,exdays) {
            exdays = exdays || 1;
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires=" + d.toGMTString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
    
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        let modalShow = getCookie('modalCookies');
        
        setTimeout(() => {
            $(".modal").addClass('d-block');

            if(modalShow !== '') {
                $("#modal-prow").removeClass('d-block');
            } else {
                $(".close-modal, .modal-sandbox").click(function(){
                    setCookie('modalCookies', 1, 30);
                    $(".modal").removeClass('d-block');
                });
            }
        }, 3000);
    },

    init() {
        this.beforeAfter();
        this.modalHomeInit();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js